module.exports = __webpack_public_path__ + "static/media/apple.04106921.png";